export default "{\n    \"replaceInvoice\": \"Replace Invoice\"\n}\n"